import React, { useState, useEffect } from 'react'
import useStateRef from 'react-usestateref';
import { DataGrid,GridToolbar,GridCellModes  } from '@mui/x-data-grid';
import { Pagination } from "@mui/material";
import Box from '@mui/material/Box';
import { Row, Col, Table,  Form, Modal, Dropdown, } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';
import Card from "../../../../../components/Card";
import CustomToggle from "../../../../../components/dropdowns";
import Button from '@mui/material/Button';
import Select from 'react-select';
import config from "../../../../../config/config";
import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import "../../../../App.css";
import { width } from '@mui/system';
import swal from 'sweetalert';
import { darken, lighten, styled } from '@mui/material/styles';

const getBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.7) : lighten(color, 0.7);

const getHoverBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

const getSelectedBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

const getSelectedHoverBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.4) : lighten(color, 0.4);

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  '& .super-app-theme--Open': {
    backgroundColor: getBackgroundColor(theme.palette.info.main, theme.palette.mode),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.info.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.info.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.info.main,
          theme.palette.mode,
        ),
      },
    },
  },
  '& .super-app-theme--Filled': {
    backgroundColor: getBackgroundColor(
      theme.palette.success.main,
      theme.palette.mode,
    ),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.success.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.success.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.success.main,
          theme.palette.mode,
        ),
      },
    },
  },
  '& .super-app-theme--PartiallyFilled': {
    backgroundColor: getBackgroundColor(
      theme.palette.warning.main,
      theme.palette.mode,
    ),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.warning.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.warning.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.warning.main,
          theme.palette.mode,
        ),
      },
    },
  },
  '& .super-app-theme--Rejected': {
    backgroundColor: getBackgroundColor(
      theme.palette.error.main,
      theme.palette.mode,
    ),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.error.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.error.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.error.main,
          theme.palette.mode,
        ),
      },
    },
  },
}));





const TableData = (props) => {
	console.log('testing page')
	
	useEffect(() => {
    setpage(1);
    setuserId(0);
    setacmaster(0);
    getLookup();
    Display();
  }, []);

const listPg = (event, value) => {
    setpage(value);
    setuserId(0);
    getLookup();
    Display();
   
  };

  const navigate = useNavigate();
  const ActionAdd = () => {
	  sessionStorage.setItem("UserManagement_Action", "Add");
	  sessionStorage.setItem("UserManagement_EditId", "0");
    navigate('../dashboard/table/admin/usermanagement/entry');
  };


  const ActionEdit = (menuName,groupId,selectGroupId,Department) => {
	  
	sessionStorage.setItem("UserManagement_Action", "Edit");
    //sessionStorage.setItem("UserManagement_EditId", editid);
    sessionStorage.setItem("UserManagement_GroupId", groupId);
    sessionStorage.setItem("UserManagement_MenuName", menuName);
    sessionStorage.setItem("UserManagement_selectGroupId", selectGroupId);
    sessionStorage.setItem("UserManagement_Department", Department);
    navigate('../dashboard/table/admin/usermanagement/entry');
  };

const ActionDelete = (editid) => {
	  
	sessionStorage.setItem("UserManagement_Action", "Delete");
    sessionStorage.setItem("UserManagement_EditId", editid);
    navigate('../dashboard/table/admin/usermanagement/entry');
  };

  const [DtUserGroup, setUserGroup]=useState([]);
  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const [GroupId, setGroupId, GroupIdRef] = useStateRef();
  const [userId, setuserId, userIdRef] = useStateRef('0');
  const [nopage, setnopage, nopageRef] = useStateRef();
  const [page, setpage, pageRef] = useStateRef('1');
  const [acmaster, setacmaster, acmasterRef] = useStateRef('0');
  const [totalCount, settotalCount, totalCountRef] = useStateRef();
  const [currentpg, setcurrentpg, currentpgRef] = useStateRef();
  const [GridData, setGridData] = useState([]);
  const handleClose1 = () => setShow1(false);
  const [isDisabled, setisDisabled]=useState(false);
  const [Search, setSearch, SearchRef] = useStateRef('');
  
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [editRowsModel, setEditRowsModel] = React.useState({});
  const [loading, setLoading] = React.useState(false)
  const [btndisabled, setDisabled] = useState('disabled');
  const [newDataRows, setRows] = React.useState([]);
  const dataRows=[];
 
  // useEffect(() => {
    
  // }, [newDataRows]);

  async function getLookup(){
    try {
      setGroupId('1');
     let postData=[];
 
 
     const results = await apiService.postCall("useradmin/Lookup",postData);
  
    if (results != "-1") {
 
      setUserGroup(results.data[0][0]);

       }
  
     } catch (error) {
       console.log(error);
     }
 }
 const BackToList = () => {
  setDisabled('disabled');
  Display();
};
 async function SaveFunc(){
  try
  {
    setLoading(true);
     
    debugger;
    sessionStorage.setItem("UserManagement_Action", "Edit");
    var results;

    
 for(var i=0;i<=newDataRows.length-1;i++){
  
        let menuName=newDataRows[i][0].menuName;
              let NewVal=newDataRows[i][0].NewVal;
        let EditVal=newDataRows[i][0].EditVal;
        let DeleteVal=newDataRows[i][0].DeleteVal;
        let ViewVal=newDataRows[i][0].ViewVal;
        let groupId=newDataRows[i][0].groupId;
        let department=newDataRows[i][0].department;
        let selectGroupId=String(GroupIdRef.current);

        let postData = {
          
          "Action" : "Edit",
          "MenuName" : menuName,
          "GroupId" : groupId,
          "selectGroupId" : selectGroupId,
          "Department" : department,
          "eBranchCode" : '2',
          "NewVal": NewVal,
          "EditVal": EditVal,
          "DeleteVal": DeleteVal,
          "ViewVal": ViewVal,
          
        }
        debugger;
         results = await apiService.postCall("useradmin/Save",postData);
         debugger;

}
  
debugger;
setLoading(false);
 if (results != "-1" && results !=undefined) {

if(results.errorCode=="8888")
{


swal({

  title: "Alert",
  text: results.data,
  icon: "info",
  button: "Ok"
  
}).then(function () {
  
});

return;

}  
if(sessionStorage.getItem("UserManagement_Action")=="Add")
 {
  swal({

    title: "Success",
    text: "Successfully Add Your Details!",
    icon: "success",
    button: "Ok"

  }).then(function () {
    BackToList();
  });

}

else if(sessionStorage.getItem("UserManagement_Action")=="Edit")
 {
  setDisabled('disabled');
  swal({

    title: "Success",
    text: "Successfully Update Your Details!",
    icon: "success",
    button: "Ok"

  }).then(function () {
    setDisabled('disabled');
    BackToList();
  });

}
 
else if(sessionStorage.getItem("UserManagement_Action")=="Delete")
{
 swal({

   title: "Success",
   text: "Successfully Delete Your Details!",
   icon: "success",
   button: "Ok"

 }).then(function () {

   BackToList();
 });

}
 
    }
  }
  catch (error) {
    console.log(error);
  }

}


async function Display() {
    try {
	
      setLoading(true);
    
      let page_no = String(pageRef.current)
      let Rows_Page = String(config.pageCount)
      let user_id = String(userIdRef.current)
      let ac_master = String(acmasterRef.current)
      let GroupId=String(GroupIdRef.current)

    
      let postData = {
        GroupId:GroupId,
      }

      let results = await apiService.postCall('useradmin/List', postData);
       
      if (results != "-1") {
        setLoading(false);
        setGridData(results.data[0]);
        settotalCount(results.totalCount);
        setcurrentpg(postData.PageNumber);
        console.log(results.data[0])
      }

    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }
  
const columns=[
 
  {
    field: 'MenuScreenMenu',
  headerName: 'Menu Name',
  width: 200,
  align: 'left',
  headerAlign: 'left',
  editable: true,
  
  },
  {
    field: 'MenuCaption',
    headerName: 'Menu Caption',
    align: 'left',
   headerAlign: 'left',
   editable: false,
   width: 200,
    },
  {
    field: 'Department',
    headerName: 'Department',
    align: 'left',
    headerAlign: 'left',
    editable: false,
    width: 200,
    },
    {
      field: 'NewVal',
      headerName: 'New',
      align: 'center',
      editable: true,
      width: 100,
      type:'boolean',
      cellClassName: '',
    },
    {
      field: 'EditVal',
      headerName: 'Edit',
      editable:true,
      type: 'bool',
      align: 'center',
      width: 100,
      type:'boolean'
    },
    {
      field: 'DeleteVal',
      headerName: 'Delete',
      align: 'center',
      editable:true,
      width: 100,
      type:'boolean'
    },
    {
      field: 'ViewVal',
      headerName: 'View',
      align: 'center',
      editable:true,
      width: 100,
      type:'boolean'
     
    }
   
]

// const handleProcessRowUpdate = (newRow, oldRow) => {
//   debugger;
//   //Here manipulate the rows depending on what you want to do
// }
const handleCellEditStop = React.useCallback((params, event) => {
  debugger;
  event.defaultMuiPrevented = true;
}, []);

const handleProcessRowUpdateError = React.useCallback((err) => {
  console.log("Error!");
   swal({

    title: "Oops...",
    text: "Something went wrong!",
    icon: "error",
    button: "Ok",
    footer: '<a href="#">'+ err +'</a>'

  }).then(function () {
    BackToList();
  });


}, []);

const handleProcessRowUpdate = (updatedRow, originalRow) => {
  debugger;
  setDisabled('disabled');
  // Find the index of the row that was edited
  const rowIndex = GridData.findIndex((row) => row.MenuName === updatedRow.MenuName);

  updatedRow.status="Filled";
  // Replace the old row with the updated row
  const updatedRows = [GridData];
  // updatedRows[rowIndex] = updatedRow;
  var editedData=[];
  editedData.push({
    'rowIndex':rowIndex,
    'menuName':updatedRow.MenuName,
    'department':updatedRow.Department,
    'NewVal':updatedRow.NewVal,
    'EditVal':updatedRow.EditVal,
    'DeleteVal':updatedRow.DeleteVal,
    'ViewVal':updatedRow.ViewVal,
    'groupId':updatedRow.groupId,
  })
  // Update the state with the new rows
  debugger;
  var restultData = containsObject(updatedRow.MenuName, dataRows);
  if (restultData) {
    var rIndex = updatedRow.rowIndex;
    var MenuName = updatedRow.MenuName;
    var NewVal = updatedRow.NewVal;
    var EditVal = updatedRow.EditVal;
    var DeleteVal = updatedRow.DeleteVal;
    var ViewVal = updatedRow.ViewVal;
    updateEditValue(NewVal, EditVal, DeleteVal,ViewVal,MenuName);

  }
  else
  {
    dataRows.push(editedData);
  }
  function containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
        
        if (list[i][0].menuName === obj) {
            return true;
        }
    }
    return false;
}
  
function updateEditValue(NewVal,EditVal,DeleteVal,ViewVal,  menuName) {
  for (var i in dataRows) {

      if (dataRows[i][0].menuName == menuName) {
        dataRows[i][0].NewVal = NewVal;
        dataRows[i][0].EditVal = EditVal;
        dataRows[i][0].DeleteVal = DeleteVal;
        dataRows[i][0].ViewVal = ViewVal;
          break; //Stop this loop, we found it!
      }
  }
}


setRows([...newDataRows, ...dataRows]);
  //setRows(current => [current, editedData]);
  //setRows(dataRows);

  setDisabled('');

  // Return the updated row to update the internal state of the DataGrid
  return updatedRow;
};


  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
           
              <div className="header-title">
                <h4 className="card-title">To Add, Modify User Management details.</h4>
              </div>
             
             
            </Card.Header>
            <Card.Body>
            <div className='container-fluid py-4 '>
                    <div className='row py-2'> 
                        <div className='col-md-6'>
                            <Form.Label>User Group</Form.Label>
                             <Select className="" id="txtUserGroup" 
                             options={DtUserGroup}
                             isDisabled={isDisabled}
                             value={DtUserGroup.filter(function(option) {
                               
                              return option.value === GroupId;
                            })}
                            onChange=
                            {
                              (e) => {
 
                                 setGroupId(e.value);
                                  Display();
                              }
                              }
                             disabled={false}>
              								
							               </Select>
                          </div>
                        
                        </div>
                        </div>

                        <div className='pt-1' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  
                 
                  <Button type="button"   variant="contained"  color="error">cancel</Button> {' '}
                  <Button type="button" variant="contained" disabled={btndisabled} onClick={SaveFunc}>Save</Button>
                </Form.Group>
              </div>

               <Box sx={{ height: 400, width: 1,
               '.MuiDataGrid-columnHeaderTitle': { 
                fontWeight: 'bold !important',
                overflow: 'visible !important'
             },
             '& .super-app-theme--cell': {
              backgroundColor: 'rgba(157, 255, 118, 0.49)',
              color: '#1a3e72',
              fontWeight: '600',
            },
            '& .super-app.positive': {
              backgroundColor: '#d47483',
              color: '#1a3e72',
              fontWeight: '600',
            },
              }}>
                  <StyledDataGrid
                   //checkboxSelection
                   editMode="row"
                   processRowUpdate={handleProcessRowUpdate}
                   onProcessRowUpdateError={handleProcessRowUpdateError}
                   //onRowModesModelChange={handleRowModesModelChange}
                
                   onCellEditStop={handleCellEditStop}
                     rows={GridData}
                    columns={columns}
                    getRowClassName={(params) => `super-app-theme--${params.row.status}`}
                    getRowId={(row) =>  row.MenuName}
                     showCellVerticalBorder 
                     showColumnVerticalBorder 
                     loading={loading}
                    slots={{ toolbar: GridToolbar }}
                   
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 10
                        }
                      }
                    }}

                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      
                      },
                    }}
                  />
                </Box>

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TableData;
